export default __webpack_public_path__ + "static/media/16.475f1fd8.png";